import {
  Box,
  Button,
  FormControl,
  InputLabel,
  makeStyles,
  MenuItem,
} from "@material-ui/core";
import { Field, Formik } from "formik";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getBrands } from "../../../redux/actions/brand.action";
import { getDepts } from "../../../redux/actions/department.action";
import CustomSelectInput from "../../inputs/CustomSelectInput";
import SearchIcon from "@material-ui/icons/Search";
import { getYearList } from "../../../redux/actions/purchaseRequest.action";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: 600,
    padding: 1,
    "& .MuiButton-root": {
      margin: theme.spacing(1),
    },
  },
  inputForm: {
    margin: theme.spacing(1, 1, 1),
    width: "25ch",
  },
  buttonForm: {
    lineHeight: "5ch",
    alignContent: "center",
    minWidth: "20ch",
  },
}));

export default function BudgetManagementFormComponent({ onSubmit }) {
  const classes = useStyles();

  const dispatch = useDispatch();
  const brandReducer = useSelector((state) => state.brandReducer);
  const departmentReducer = useSelector((state) => state.departmentReducer);
  const { years } = useSelector((state) => state.purchaseRequestReducer);
  const {
    result: { companyid, countryid, secureid },
  } = useSelector((state) => state.loginReducer);

  useEffect(() => {
    dispatch(getBrands(countryid, companyid, secureid));
    dispatch(getYearList());
    return () => {};
  }, []);

  const renderYear = () => {
    if (years.isLoading) {
      return <MenuItem>Loading...</MenuItem>;
    }
    return years.data.map((item) => (
      <MenuItem MenuItem={item.YEAR_CODE} value={item.YEAR_CODE}>
        {item.YEAR_CODE}
      </MenuItem>
    ));
  };

  const renderBrandItem = () => {
    if (brandReducer.isFetching) {
      return <MenuItem>Loading...</MenuItem>;
    }
    return brandReducer.result.map((item) => (
      <MenuItem key={item.ORG_BRAND_ID} value={item.ORG_BRAND_ID}>
        {item.BRAND}
      </MenuItem>
    ));
  };

  const renderDepartment = () => {
    if (departmentReducer.isFetching) {
      return <MenuItem>Loading...</MenuItem>;
    }

    return departmentReducer.result.map((item) => (
      <MenuItem
        MenuItem={item.ORG_DEPARTMENT_ID}
        value={item.ORG_DEPARTMENT_ID}
      >
        {item.department}
      </MenuItem>
    ));
  };

  const handleChangeBrand = (event) => {
    dispatch(getDepts(countryid, companyid, secureid, event.target.value));
  };

  return (
    <div className={classes.modal}>
      <Formik
        initialValues={{
          PR_YEAR: "",
          PR_BRANDID: "",
          PR_DEPARTID: "",
          PR_COUNTRYID: countryid,
          PR_COMPANYID: companyid,
        }}
        validate={(values) => {
          const errors = {};

          if (!values.PR_YEAR) {
            errors.PR_YEAR = "Required";
          }

          if (!values.PR_BRANDID) {
            errors.PR_BRANDID = "Required";
          }

          if (!values.PR_DEPARTID) {
            errors.PR_DEPARTID = "Required";
          }

          return errors;
        }}
        onSubmit={(values, { setSubmitting }) => {
          // search
          onSubmit(values);
          setSubmitting(false);
        }}
        render={({
          submitForm,
          resetForm,
          isSubmitting,
          setSubmitting,
          touched,
          errors,
          values,
          setFieldValue,
        }) => (
          <>
            <Box display="flex">
              <Box>
                <FormControl className={classes.inputForm}>
                  <InputLabel
                    error={Boolean(
                      errors.PR_YEAR && touched.PR_YEAR && errors.PR_YEAR
                    )}
                    id="select-year-label"
                  >
                    BUDGET YEAR
                  </InputLabel>
                  <Field
                    component={CustomSelectInput}
                    name="PR_YEAR"
                    label="Year"
                    labelId="select-year-label"
                    size="small"
                    error={Boolean(
                      errors.PR_YEAR && touched.PR_YEAR && errors.PR_YEAR
                    )}
                    onChange={() => {}}
                  >
                    {renderYear()}
                  </Field>
                </FormControl>

                <FormControl className={classes.inputForm}>
                  <InputLabel
                    id="select-brand-label"
                    error={Boolean(
                      errors.PR_BRANDID &&
                        touched.PR_BRANDID &&
                        errors.PR_BRANDID
                    )}
                  >
                    BRAND
                  </InputLabel>
                  <Field
                    component={CustomSelectInput}
                    name="PR_BRANDID"
                    label="Brand"
                    labelId="select-brand-label"
                    size="small"
                    error={Boolean(
                      errors.PR_BRANDID &&
                        touched.PR_BRANDID &&
                        errors.PR_BRANDID
                    )}
                    onChange={handleChangeBrand}
                  >
                    {renderBrandItem()}
                  </Field>
                </FormControl>

                <FormControl className={classes.inputForm}>
                  <InputLabel
                    error={Boolean(
                      errors.PR_DEPARTID &&
                        touched.PR_DEPARTID &&
                        errors.PR_DEPARTID
                    )}
                    id="select-depart-label"
                  >
                    DEPARTMENT
                  </InputLabel>
                  <Field
                    component={CustomSelectInput}
                    name="PR_DEPARTID"
                    label="Department"
                    labelId="select-depart-label"
                    size="small"
                    onChange={(e) => {}}
                    error={Boolean(
                      errors.PR_DEPARTID &&
                        touched.PR_DEPARTID &&
                        errors.PR_DEPARTID
                    )}
                  >
                    {renderDepartment()}
                  </Field>
                </FormControl>
              </Box>
              <Box>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={submitForm}
                  className={classes.buttonForm}
                  disabled={isSubmitting}
                  size="small"
                >
                  <SearchIcon />
                  Search
                </Button>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={(e) => {
                    e.preventDefault();
                    resetForm({});
                  }}
                  className={classes.buttonForm}
                  disabled={isSubmitting}
                  size="small"
                >
                  Clear
                </Button>
              </Box>
            </Box>
          </>
        )}
      />
    </div>
  );
}
